export default {
  data() {
    return {
      discount: 0,
      isCouponValid: false,
      couponMessage: null,
      offer_id: 0,
      razorpay_offer_id: null,
      offer: {},
      offerDetails: [],
    };
  },
  methods: {
    async applyCoupon(couponCode, student_id, selected_plan_id, amount) {
      this.discount = 0;
      this.isCouponValid = false;
      this.offer_id = 0;
      this.razorpay_offer_id = null;
      const offers = await this.$api.offers.find({ offer_name: couponCode });
      if (offers.total === 0) {
        this.couponMessage = "Coupon Code is wrong";
        return;
      }

      const {
        discount_rate,
        maximum_discount_amount,
        discount_type,
        redemption_type,
      } = offers.data[0];

      this.offer_id = offers.data[0].id;
      this.razorpay_offer_id = offers.data[0].razorpay_offer_id;
      const offer_details = await this.$api.offerDetails.find({
        offer_id: this.offer_id,
        plan_id: selected_plan_id,
      });
      if (offer_details.total === 0) {
        return;
      }
      const { plan_id, offer_type, limits } = offer_details.data[0];
      //console.log("step 2 ", offer_details.data[0]);
      this.isCouponValid = await this.is_coupon_valid(
        redemption_type,
        this.offer_id,
        plan_id,
        student_id
      );
      if (this.isCouponValid) {
        this.discount = this.calculate_discount(
          amount,
          discount_rate,
          discount_type,
          maximum_discount_amount
        );
      }
    },

    async getOffer(couponCode) {
      const offers = await this.$api.offers.find({
        offer_name: couponCode,
        offer_status: "Enabled",
      });
      if (
        offers.total === 0 ||
        couponCode === undefined ||
        couponCode.length === 0
      ) {
        this.discount = 0;
        this.isCouponValid = false;
        this.couponMessage = "Coupon Code is wrong";
        return;
      }

      this.offer = offers.data[0];
      this.offer_id = offers.data[0].id;
      this.razorpay_offer_id = offers.data[0].razorpay_offer_id;
      const offer_details = await this.$api.offerDetails.find({
        offer_id: this.offer_id,
      });
      if (offer_details.total === 0) {
        this.isCouponValid = false;
        return;
      }
      this.isCouponValid = true;
      this.offerDetails = offer_details.data;
    },

    calculate_discount(amount, rate, method, maximum_discount_amount) {
      if (method === "Percentage") {
        let discount = (amount * rate) / 100;
        return discount >= maximum_discount_amount
          ? maximum_discount_amount
          : discount;
      } else {
        return rate;
      }
    },
    async is_coupon_valid(redemption_type, offer_id, plan_id, user_profile_id) {
      if (redemption_type === "Single Use") {
        const child_coupon = await this.$api.studentPlanSubscriptions.find({
          student_id: user_profile_id,
          offer_id,
        });

        const status = child_coupon.total === 0 ? true : false;
        this.couponMessage = status
          ? "Coupon is applied"
          : "Coupon Code is already used";
        return status;
      } else {
        this.couponMessage = "Coupon is applied";
        return true;
      }
    },
    async claimCoupon(
      code,
      country_id,
      cartValue,
      user = null,
      claimFrom = "Subscription"
    ) {
      try {
        const res = await this.$api.offers.find({
          controller: "claim-coupon",
          code,
          country_id,
          platform: "web",
          user,
          cartValue,
          claimFrom,
        });
        this.isCouponValid = true;
        return res;
      } catch (error) {
        this.isCouponValid = false;
        throw error;
      }
    },
  },
};
